// extracted by mini-css-extract-plugin
module.exports = {"Author":"Author_Author__0gyYG","Image":"Author_Image__YyoIl","Content":"Author_Content__aR0H9","Title":"Author_Title__tWqAm","Name":"Author_Name__Nsrw6"};